/// <reference path="app.ts" />
namespace Cfnc {
    "use strict";


    export class Config implements IConfig {
        appErrorPrefix: string;
        docTitle: string;
        version: string;
        apiHost: string;
        crossroadsUrl: string;
        crossroadsApiUrl: string;
        authCookieName: string;
        rdsUrl: string;
        public environment: string;
        public cfncUrl: string;
        public transitionsUrl: string;
        public javaUrl: string;
        public umbracoUrl: string;
        public authHost: string;
        public residencyUrl: string;
        public updateAddressAtLogin: boolean;
        public updateEmailAtLogin: boolean;
        public updatePasswordAtLogin: boolean;
        public cfncAddressError: boolean;
        public cfncEmailError: boolean;
        homeRedirect: boolean;
        public newPhoneNumbersEnabled: string;
        public phoneNumberInvalid: boolean;
        public ncassistUrl: string;
        public ncassistDevUrl: string;
        public ncCareersUrl: string;
        public hesEnvironment: string;
        public nextStepTypeFormId: string;

        events: IEvents = {
            controllerActivateSuccess: "controller.activateSuccess",
            spinnerToggle: "spinner.toggle",
            login: "authentication.login",
            logout: "authentication.logout",
            register: "authentication.register",
            reloadUser: "authentication.reloadUser"
        };

        constructor() {
            this.apiHost = "https://localhost:44316";
            this.crossroadsUrl = "https://localhost:44389";
            this.crossroadsApiUrl = "https://localhost:44353";
            this.appErrorPrefix = "[CFNC Error] "; // configure the exceptionHandler decorator
            this.docTitle = "College for North Carolina - ";
            this.version = "1.0.0";
            this.cfncUrl = "https://localhost:44302";
            this.javaUrl = "https://test9.cfnc.org";
            this.umbracoUrl = "https://localhost:44384";
            this.authHost = "https://localhost:44373";
            this.transitionsUrl = "https://test1.cfnc.org";
            this.residencyUrl = "https://testncresidency.cfnc.org/residencyInfo/";
            this.authCookieName = ".CfncIdentityLocal";
            this.updateAddressAtLogin = true;
            this.updateEmailAtLogin = true;
            this.homeRedirect = false;
            this.newPhoneNumbersEnabled = "npne-false";
            this.ncassistUrl = "https://testncassist.cfnc.org";
            this.ncassistDevUrl = "https://local.cfnc.org:8443";
            this.ncCareersUrl = "https://dev1.nc-cis.cloud"
            this.hesEnvironment = "[hes-environment]";
            this.nextStepTypeFormId = "rNMdAwPI";

            toastr.options.timeOut = 4000;
            toastr.options.positionClass = "toast-bottom-right";
        }
    }

    var app: ng.IModule = angular.module("app");
    var cfncConfig = new Config();

    app.value("config", cfncConfig);


    // #region Configure the common services via commonConfig
    app.config(["$httpProvider", "$logProvider", "$locationProvider", "commonConfigProvider", "KeepaliveProvider", "IdleProvider", ($httpProvider, $logProvider: ng.ILogProvider, $locationProvider: ng.ILocationProvider, cfg: ICommonProvider, KeepaliveProvider, IdleProvider): void => {
        // turn debugging off/on (no info or warn)
        if ($logProvider.debugEnabled) {
            $logProvider.debugEnabled(true);
        }

        $locationProvider
            .html5Mode(true);

        cfg.config.controllerActivateSuccessEvent = cfncConfig.events.controllerActivateSuccess;
        cfg.config.spinnerToggleEvent = cfncConfig.events.spinnerToggle;
        cfg.config.debug = true;

        cfg.config.login = cfncConfig.events.login;
        cfg.config.logout = cfncConfig.events.logout;
        cfg.config.register = cfncConfig.events.register;
        cfg.config.reloadUser = cfncConfig.events.reloadUser;

        cfg.config.apiHost = cfncConfig.apiHost;
        cfg.config.xapHost = cfncConfig.transitionsUrl;
        cfg.config.homeUrl = cfncConfig.umbracoUrl;
        $httpProvider.interceptors.push(ResponseInterceptor.serviceId);

        IdleProvider.idle(1800);
        IdleProvider.timeout(120);
    }]);
    // #endregion

    //#region Configure the Restangular Service
    app.config(["RestangularProvider", (RestangularProvider: Restangular.IProvider) => {
        RestangularProvider.setBaseUrl(cfncConfig.apiHost);
    }]);
    //#endregion

    app.config(["$uibModalProvider", ($modalProvider: ng.ui.bootstrap.IModalProvider) => {
        $modalProvider.options.backdrop = "static";
    }]);

    app.config(["uiGmapGoogleMapApiProvider", (uiGmapGoogleMapApiProvider) => {
        uiGmapGoogleMapApiProvider.key = "AIzaSyCxW80cb72fjK5k4dHND0QdfZ1uuvqIK-4";
    }]);
} 